import React from 'react';

// 期間フィルター（YYYY-MM-DD 同士の文字列比較）
export function inDateRange(dateStr: string, from: string, to: string): boolean {
  const d = dateStr.slice(0, 10);
  if (from && d < from) return false;
  if (to && d > to)     return false;
  return true;
}

const dateInputStyle: React.CSSProperties = {
  border: '1px solid #E5E7EB', borderRadius: 6, padding: '4px 8px', fontSize: 13, outline: 'none', background: '#fff',
};

function fmtYmd(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

type Preset = { label: string; range: () => [string, string] };

const DATE_PRESETS: Preset[] = [
  { label: '今日',    range: () => { const t = fmtYmd(new Date()); return [t, t]; } },
  { label: '直近7日', range: () => { const n = new Date(); const s = new Date(); s.setDate(n.getDate() - 6); return [fmtYmd(s), fmtYmd(n)]; } },
  { label: '今月',    range: () => { const n = new Date(); return [fmtYmd(new Date(n.getFullYear(), n.getMonth(), 1)), fmtYmd(new Date(n.getFullYear(), n.getMonth() + 1, 0))]; } },
  { label: '先月',    range: () => { const n = new Date(); return [fmtYmd(new Date(n.getFullYear(), n.getMonth() - 1, 1)), fmtYmd(new Date(n.getFullYear(), n.getMonth(), 0))]; } },
];

// 年度（4月1日〜翌年3月31日）。offset=0で今年度、-1で昨年度。
function fiscalYearRange(offset: number): [string, string] {
  const n = new Date();
  // 1〜3月は前年が年度の開始年
  const fyStart = (n.getMonth() + 1 >= 4 ? n.getFullYear() : n.getFullYear() - 1) + offset;
  return [`${fyStart}-04-01`, `${fyStart + 1}-03-31`];
}

const FISCAL_YEAR_PRESETS: Preset[] = [
  { label: '今年度', range: () => fiscalYearRange(0) },
  { label: '昨年度', range: () => fiscalYearRange(-1) },
];

export const DateRangeFilter: React.FC<{
  from: string; to: string;
  onFrom: (v: string) => void; onTo: (v: string) => void;
  // 年度（今年度・昨年度）のプリセットを追加表示する（有給管理など年間で見る画面向け）
  showFiscalYear?: boolean;
}> = ({ from, to, onFrom, onTo, showFiscalYear = false }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#374151', flexWrap: 'wrap' }}>
    <div style={{ display: 'flex', gap: 2, background: '#F1F5F9', borderRadius: 8, padding: 2 }}>
      {[...DATE_PRESETS, ...(showFiscalYear ? FISCAL_YEAR_PRESETS : [])].map(p => {
        const [pf, pt] = p.range();
        const active = from === pf && to === pt;
        return (
          <button key={p.label} onClick={() => { onFrom(pf); onTo(pt); }}
            style={{
              padding: '4px 10px', border: 'none', borderRadius: 6, cursor: 'pointer',
              fontSize: 12, fontWeight: active ? 700 : 500,
              background: active ? '#fff' : 'transparent',
              color: active ? '#1e40af' : '#64748b',
              boxShadow: active ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            }}>{p.label}</button>
        );
      })}
    </div>
    <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      期間：
      <input type="date" value={from} onChange={e => onFrom(e.target.value)} style={dateInputStyle} />
      〜
      <input type="date" value={to} onChange={e => onTo(e.target.value)} style={dateInputStyle} />
    </label>
    {(from || to) && (
      <button onClick={() => { onFrom(''); onTo(''); }}
        style={{ padding: '4px 10px', background: '#F1F5F9', color: '#64748b', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
        クリア
      </button>
    )}
  </div>
);
